import { render, staticRenderFns } from "./cnvAndmRNA.vue?vue&type=template&id=5b3cecb8&"
import script from "./cnvAndmRNA.vue?vue&type=script&lang=js&"
export * from "./cnvAndmRNA.vue?vue&type=script&lang=js&"
import style0 from "./cnvAndmRNA.vue?vue&type=style&index=0&id=5b3cecb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports